export const CONTEXT_MENU_CODE = {
	CONFIG_TRANSFER_INFO: "configTransferInfo",
};
